export default (searchString) => {
    const strings = searchString.substr(1).split('&') // the substr removes the preceding '?'
    const pairs = strings.map(string => {
        return [string.split('=')[0], string.split('=')[1]]
    })
    return Object.fromEntries(pairs)
}